import type { FetcherAxiosInstance } from '../fetcher';

export const createCodeApi = (Fetcher: FetcherAxiosInstance) => ({
  requestCode({ phone = '', channel = 'sms' } = {}) {
    return Fetcher.post('/code', { phone, channel });
  },

  verifyCode({ phone = '', code = '', channel = 'sms' } = {}) {
    return Fetcher.post('/code/_verify', { phone, code, channel });
  },
});
